/**
 * 사이트 설정 + DB 가격 서비스
 */
import { db } from '../firebase/config';
import {
  doc, getDoc, setDoc, getDocs, updateDoc,
  collection, serverTimestamp,
} from 'firebase/firestore';

const SETTINGS_DOC = 'site_settings/main';

// ───── 사이트 설정 조회 ─────
export const getSiteSettings = async () => {
  const snap = await getDoc(doc(db, SETTINGS_DOC));
  if (!snap.exists()) {
    return {
      serviceName: '이음',
      contactPhone: '',
      commissionRate: { conversion: 10, consult: 5, referral: 5 },
      referralDurationMonths: 12,
      autoAssign: true,
      newRequestNotif: true,
      activeServices: {
        moving: true,
        internet_tv: true,
        cleaning: true,
        interior: true,
        aircon: true,
        water_purifier: true,
        kiosk: true,
      },
    };
  }
  return snap.data();
};

// ───── 사이트 설정 저장 ─────
export const updateSiteSettings = async (data) => {
  await setDoc(doc(db, SETTINGS_DOC), {
    ...data,
    updatedAt: serverTimestamp(),
  }, { merge: true });
};

// ───── DB 가격 조회 ─────
export const getDbPricing = async (category) => {
  const colName = `db_price_${category}`;
  const snap = await getDocs(collection(db, colName));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

// ───── DB 가격 수정 ─────
export const updateDbPricing = async (category, id, data) => {
  const colName = `db_price_${category}`;
  await updateDoc(doc(db, colName, id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
};
